<template>
  <div>
    <shifts-form v-if="editingAttendingShifts" :initial-selected-shift-ids="attendingShiftIds"
                 :submit-button-label="i18n.t('public.events.save_updated_shifts')" @submit="saveUpdate" />

    <template v-else>
      <p>{{ i18n.t('public.events.attending_shifts') }}</p>

      <div class="d-grid">
        <div v-for="day in Object.keys(shiftsByDay)" :key="day">
          <h4 v-if="showDaysForShifts && attendingShiftsForDay(day).length > 0" class="mt-2 mb-2">
            {{ day }}
          </h4>
          <ul>
            <li v-for="shift of attendingShiftsForDay(day)" :key="shift.id">
              {{ shift.label }}
            </li>
          </ul>
        </div>

        <light-button :label="i18n.t('public.events.edit_shifts')" @click="editAttendingShifts" />
      </div>
    </template>
  </div>
</template>

<script>
import LightButton from '@/components/buttons/light-button'
import { mapGetters, mapMutations, mapState } from 'vuex'
import ShiftsForm from './shifts-form'

export default {
  components: { LightButton, ShiftsForm },

  computed: {
    ...mapState(['attendingShiftIds', 'editingAttendingShifts']),
    ...mapGetters(['shiftsByDay']),

    showDaysForShifts() {
      return Object.keys(this.shiftsByDay).length > 1
    }
  },

  methods: {
    ...mapMutations(['editAttendingShifts']),

    attendingShiftsForDay(day) {
      const component = this
      return this.shiftsByDay[day].filter((s) => component.attendingShiftIds.includes(s.id))
    },

    saveUpdate(selectedShiftIds) {
      this.$store.dispatch('updateAttendee', { shiftIds: selectedShiftIds })
    }
  }
}
</script>
